export enum SessionActivityName {
    AudioVideo = 'audio_video',
    Audio = 'audio',
    CoBrowsing = 'co_browsing',
    TextChat = 'text_chat',
    SIP = 'sip',
    ScreenSharing = 'screen_sharing',
    Avatar = 'avatar',
    AgentChatbot = 'agent_chatbot'
}
